import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  RIconFile,
  RIconPaperPlane,
  RIconPC,
  RIconPerson,
} from "../../components/Icons";
import { RIconRRB } from "../../components/Icons/RIconRRB";
import { StatCard } from "./StatCard";
import DataTable from "../../components/DataTable";
import { PAGE_LENGTH } from "../../common/constants";
import PageHeaderActions from "../../components/General/PageHeaderActions";
import * as ControlPanelApi from "../../api/ControlPanelApi";

const ControlAdminCount = ({ data = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 25,
    q: "",
    _sort: "id",
    _order: "asc",
    // status:"1"
  });
  const initialState = {
    sortBy: [{ id: "id", desc: false }],
    pageSize: filter._limit,
    pageIndex: 0,
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      fetchRRBs();
    }, 100);
    return () => clearTimeout(getData);
  }, [filter]);

  const fetchRRBs = async () => {
    setIsLoading(true);
    try {
      await ControlPanelApi.getControlPanelDashboard(filter).then(
        ({ data }) => {
          if (data) {
            setTotalRecords(data.totalRecords);
            setRows(data.data);
          }
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // divisions: divisionCounts,
  // cities: cityCounts,
  // centers: centerCounts,
  // users: userCounts,
  // exams: examCounts,
  // reports: reportCounts,
  const columns = useMemo(
    () => [
      {
        Header: "RRB",
        accessor: "rrb_name",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Divisions",
        accessor: "divisions",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Cities",
        accessor: "cities",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Centers",
        accessor: "centers",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Users",
        accessor: "users",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Exams",
        accessor: "exams",
        className: "w-auto",
        disableSortBy: true,
      },
      {
        Header: "Reports Submitted",
        accessor: "reports",
        className: "w-auto",
        disableSortBy: true,
      },
    ],
    []
  );

  if (!data) return;
  return (
    <Fragment>
      <div className='d-flex gap-3'>
        <StatCard
          icon={<RIconPerson />}
          bgClass='custom-bg-blue'
          title={data?.totalUsers}
          subtitle={"Users"}
          colSize='col-6 col-md-4 col-xxl'
        />
        <StatCard
          icon={<RIconPC />}
          bgClass='custom-bg-blue'
          title={data?.centers}
          subtitle='Centers'
          colSize='col-6 col-md-4 col-xxl'
        />
        <StatCard
          icon={<RIconFile />}
          bgClass='custom-bg-blue'
          title={data?.totalExams}
          subtitle='Exams'
          colSize='col-6 col-md-4 col-xxl'
        />
        <StatCard
          icon={<RIconPaperPlane width={30} height={28.73} />}
          bgClass='custom-bg-blue'
          title={data?.reportsSubmitted}
          subtitle='Reports Submitted'
          colSize='col-6 col-md-4 col-xxl'
        />
      </div>
      <div>
        <DataTable
          header={<PageHeaderActions title='RRB Wise Stats' />}
          columns={columns}
          data={rows}
          initialState={initialState}
          totalRecords={totalRecords}
          setFilter={setFilter}
          tableHooks={() => {}}
          defaultPageLength={[25, 50, 100]}
          isLoading={isLoading}
          manual={true}
          align='table-vcenter'
        />
      </div>
    </Fragment>
  );
};

export default ControlAdminCount;
